import { render, staticRenderFns } from "./specialColumn.vue?vue&type=template&id=1c035921&scoped=true"
import script from "./specialColumn.vue?vue&type=script&lang=js"
export * from "./specialColumn.vue?vue&type=script&lang=js"
import style0 from "./specialColumn.vue?vue&type=style&index=0&id=1c035921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c035921",
  null
  
)

export default component.exports